import React from 'react';
import { useTranslation } from 'react-i18next';
import { faqs } from '../data/mock';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  const { t } = useTranslation();

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cyan-100 px-4 py-2 rounded-full mb-4">
            <HelpCircle className="w-4 h-4 text-cyan-700" />
            <span className="text-sm font-semibold text-cyan-700">{t('faq.badge')}</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('faq.title')} <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-600 to-blue-600">{t('faq.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('faq.description')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="border-2 border-cyan-200 rounded-xl px-6 hover:border-cyan-400 transition-colors duration-300 shadow-md hover:shadow-lg"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Contact CTA */}
          <div className="mt-12 text-center p-8 bg-gradient-to-r from-cyan-100 to-blue-100 rounded-2xl border-2 border-cyan-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              {t('faq.notFound')}
            </h3>
            <p className="text-gray-600 mb-6">
              {t('faq.notFoundDesc')}
            </p>
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white font-semibold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              {t('faq.contactUs')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
